if (!customElements.get('card-product-slider')) {
  class CardProductSlider extends HTMLElement {
    constructor() {
      super();
      this.boundSync = () => this.syncHeights();
    }

    connectedCallback() {
      this.sliderWrapper = this.querySelector('.swiper-wrapper');
      this.requiresFetch = this.hasAttribute('data-url');
      this.parent = this.closest('.product-feed') || this.parentElement;

      if (this.sliderWrapper && this.sliderWrapper.classList.contains('grid_layout')) {
        this.syncHeights();
        window.addEventListener('resize', this.boundSync, { passive: true });
        return;
      }

      this.classList.add('card-product-slider--native');

      if (this.requiresFetch) {
        this.fetchItems();
        return;
      }

      this.bindControls();
      this.syncHeights();
      window.addEventListener('resize', this.boundSync, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.boundSync);
    }

    syncHeights() {
      const textSlide = this.querySelector('.products-feed__card-text-custom-slide');
      const actionElement = this.querySelector('.product-card__actions');

      if (textSlide && actionElement) {
        textSlide.style.height = `${actionElement.offsetHeight}px`;
      }
    }

    bindControls() {
      if (this.controlsBound) return;
      this.controlsBound = true;

      const options = JSON.parse(this.getAttribute('data-swiper-options') || '{}');
      const prev = options.navigation && document.querySelector(options.navigation.prevEl);
      const next = options.navigation && document.querySelector(options.navigation.nextEl);
      const amount = () => {
        const slide = this.querySelector('.card-product-slider__slide');
        return slide ? slide.getBoundingClientRect().width + 2 : this.clientWidth * 0.5;
      };

      if (prev) {
        prev.addEventListener('click', (e) => {
          e.preventDefault();
          this.sliderWrapper.scrollBy({ left: -amount(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', (e) => {
          e.preventDefault();
          this.sliderWrapper.scrollBy({ left: amount(), behavior: 'smooth' });
        });
      }

      this.querySelectorAll('product-card').forEach((card) => {
        if (typeof card.init === 'function') card.init();
      });

      const quickCart = document.querySelector('quick-cart-drawer');
      if (
        this.hasAttribute('data-init-quick-cart') &&
        quickCart &&
        typeof quickCart.init === 'function' &&
        this.querySelector('.card-product-slider__slide')
      ) {
        quickCart.init();
      }
    }

    fetchItems() {
      if (!this.parent) return;
      fetch(this.getAttribute('data-url'))
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const wrapper = html.querySelector('.swiper-wrapper');

          if (wrapper && wrapper.innerHTML.trim().length) {
            this.sliderWrapper.innerHTML = wrapper.innerHTML;
            this.parent?.classList.remove('hidden');
            this.bindControls();
            this.syncHeights();
            window.addEventListener('resize', this.boundSync, { passive: true });
            document.dispatchEvent(new Event('product-card:media:refresh'));
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  customElements.define('card-product-slider', CardProductSlider);
}
